const config = {
  version: '1.0.0',
  updateTime: Number(process.env.REACT_APP_BUILD_TIME)
};

export default config;
